












import {
    translate,
    availableLanguages,
} from "@/services/translate.service";

export interface Language {
    name: string
    locale: string
}

export default {
    props: ['small','initialLanguage'],
    data() {
        return {
            selectedLanguage: { name: '', locale: '' },
            languages: [],
        };
    },
    methods: {
        getFlagURL(locale: string) {
            if (!locale){
                locale = 'world';
            }
            return `/assets/img/flags/${locale}.svg`;
            // means u have neither name nor site  
        },
        onChange(language: any) {
            this.selectedLanguage = language;
            console.log('onChange', language, this.selectedLanguage);
            this.$emit("change", language);
        },
        setLanguage(locale) {
                this.languages.forEach(l => {
                    if (l.locale == locale) {
                        this.selectedLanguage = l;
                    }
                });
        },

    },
    mounted() {
        const languages = availableLanguages();
        console.log('i18n', this.$i18n.availableLocales);
        this.languages.push({ name: this.$i18n.t('SHOW_ALL'), locale: null },)
        languages.forEach(l => {
            this.languages.push({ name: this.$i18n.t(l), locale: l },)
        });

        if (this.initialLanguage){
            this.selectedLanguage = this.initialLanguage;
        }else{
            this.selectedLanguage = this.languages[1];
        }

   
        // this.$emit("change", this.selectedLanguage);
        console.log('mounted', languages, this.langs);

    },
    computed: {
        currentLocale() {
            return this.$store.state.lang;
        }
    },
    watch: {
        currentLocale: {
            handler: function (newValue) {
                console.log('locale changed', newValue);
                this.setLanguage(newValue);
            },
            deep: true
        }
    },

    components: {
    }
}
